import axios from 'axios';
import authHeader from './auth.header';

const API_URL = process.env.VUE_APP_API_URL;

class Typo3Service {
	getLatestVersions() {
		return axios.get(API_URL + 'typo3', {headers: authHeader()});
	}
}

export default new Typo3Service();
